import withBase from '../base'
import Module from './module'

export default withBase(Module)
